import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ChevronUp, ChevronDown } from "lucide-react";
import { api } from "../../lib/api";
import { Btn, Loading, ErrorState, Empty, text } from "./ui";

export default function SectionsPanel() {
  const [rows, setRows] = useState([]);
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const load = async () => {
    setLoading(true);
    setError(false);
    try {
      const { data } = await api.get("/admin/sections");
      setRows(Array.isArray(data) ? data : []);
    } catch (e) {
      setError(true);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  const move = (i, dir) => {
    const j = i + dir;
    if (j < 0 || j >= rows.length) return;
    const arr = [...rows];
    [arr[i], arr[j]] = [arr[j], arr[i]];
    setRows(arr);
  };
  const toggle = (i) => { const arr = [...rows]; arr[i] = { ...arr[i], enabled: !arr[i].enabled }; setRows(arr); };

  const save = async () => {
    setSaving(true);
    try { const { data } = await api.put("/admin/sections", rows); setRows(data); toast.success("Sections enregistrées"); }
    catch { toast.error("Erreur"); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <h2 className="font-display text-3xl">Sections & ordre</h2>
        <div className="flex items-center gap-3">
          <a data-testid="sections-preview" href="/?preview=1" target="_blank" rel="noreferrer"
            className="text-xs tracking-widest uppercase px-5 py-2.5 border border-[#292929] hover:border-white transition-colors duration-300">
            Aperçu
          </a>
          <Btn data-testid="sections-save" variant="solid" onClick={save} disabled={saving}>{saving ? "..." : "Enregistrer"}</Btn>
        </div>
      </div>
      <p className="text-muted-eff text-sm mb-8 max-w-lg">Activez, désactivez et réordonnez les sections du site public. Le Hero et le Footer restent recommandés.</p>
      {loading ? <Loading /> : error ? <ErrorState onRetry={load} /> : (
      <div className="border-t border-[#292929]">
        {rows.length === 0 && <Empty label="Aucune section." />}
        {rows.map((r, i) => (
          <div key={r.key} data-testid={`section-row-${r.key}`} className="border-b border-[#292929] py-4 flex items-center gap-4">
            <div className="flex flex-col">
              <button onClick={() => move(i, -1)} className="text-muted-eff hover:text-white"><ChevronUp className="w-4 h-4" /></button>
              <button onClick={() => move(i, 1)} className="text-muted-eff hover:text-white"><ChevronDown className="w-4 h-4" /></button>
            </div>
            <div className="w-8 text-muted-eff text-sm">{String(i + 1).padStart(2, "0")}</div>
            <div className="flex-1">{text(r.label)}</div>
            <button data-testid={`section-toggle-${r.key}`} onClick={() => toggle(i)}
              className={`text-[10px] tracking-widest uppercase border px-3 py-1.5 transition-colors ${r.enabled ? "border-white" : "border-[#292929] text-muted-eff"}`}>
              {r.enabled ? "Activé" : "Désactivé"}
            </button>
          </div>
        ))}
      </div>
      )}
    </div>
  );
}
